import { FormikProps } from "formik";
import _ from "lodash";

import { AccessAlarmOutlinedIcon } from "icons";
import theme from "theme";
import { colors } from "theme/palette";

import Button from "components/Button";
import Select from "components/Select";
import Stack from "components/Stack";
import Switch from "components/Switch";
import Text from "components/Text";

import {
  INotificationEmailValues,
  INTERVAL_TIME_OPTIONS,
} from "entities/Memo/components/Sections/MemoESignatureDrawer/constants";

const MemoESignatureReminder = ({
  onIntervalTimeChange,
  formik,
  disableSubmit,
  onRemindersProcessStatusChange,
}: {
  formik: FormikProps<INotificationEmailValues>;
  onIntervalTimeChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disableSubmit?: boolean;
  onRemindersProcessStatusChange: ({
    remindersEnabled,
  }: {
    remindersEnabled: boolean;
  }) => void;
}) => (
  <Stack>
    <Stack
      direction="row"
      sx={{
        padding: 1.5,
        backgroundColor: colors.gray10,
        borderRadius: "8px",
        justifyContent: "space-between",
      }}
    >
      <Stack alignItems="center" direction="row" gap={1.5}>
        <AccessAlarmOutlinedIcon
          sx={{
            width: "32px",
            height: "32px",
            color: formik.values.reminders_enabled
              ? colors.blue100
              : colors.gray60,
          }}
        />
        <Stack>
          <Text
            variant="text2"
            fontWeight={900}
            color={
              formik.values.reminders_enabled ? colors.black : colors.gray60
            }
          >
            Automated reminder
          </Text>
          <Stack direction="row" alignItems="center" gap={1}>
            <Text
              variant="text4"
              color={
                formik.values.reminders_enabled ? colors.black : colors.gray40
              }
            >
              Set an automated reminder email to be sent out at an interval of
              every
            </Text>
            <Select
              {...formik.getFieldProps("days_interval_time")}
              options={INTERVAL_TIME_OPTIONS}
              size="small"
              onChange={onIntervalTimeChange}
              disabled={!formik.values.reminders_enabled}
              color="primary"
              sx={{
                backgroundColor: colors.white,
                "& .MuiOutlinedInput-root": {
                  width: "56px",
                  height: "26px",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: colors.blue100,
                  textTransform: "uppercase",
                  fontWeight: 600,
                  fontSize: "12px",
                  color: colors.blue100,
                },
              }}
            />
            <Text
              variant="text4"
              color={
                formik.values.reminders_enabled ? colors.black : colors.gray40
              }
            >
              day(s)
            </Text>
          </Stack>
        </Stack>
      </Stack>
      {!_.isNil(disableSubmit) && formik.values.reminders_enabled && (
        <Button
          onClick={formik.submitForm}
          sx={{
            alignSelf: "flex-end",
            justifySelf: "flex-end",
            padding: theme.spacing(0.2, 1),
            height: "fit-content",
          }}
          variant="outlined"
          color="secondary"
          disabled={disableSubmit}
        >
          <Text variant="text4" fontWeight={500}>
            Save settings
          </Text>
        </Button>
      )}
    </Stack>
    <Stack direction="row" alignItems="center" alignSelf="flex-end">
      <Text fontWeight={500} variant="text3">
        Automated reminder enabled
      </Text>
      <Switch
        {...formik.getFieldProps("reminders_enabled")}
        value={formik.values.reminders_enabled}
        checked={formik.values.reminders_enabled}
        onChange={(event) =>
          onRemindersProcessStatusChange({
            remindersEnabled: event.target.checked,
          })
        }
      />
    </Stack>
  </Stack>
);

export default MemoESignatureReminder;
